import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';

import {
  defaultRejectHandler,
  stringifyErrorMessage,
} from '../../utils/utility';

import {
  listOtherEquipmentInZone,
  addOtherEquipmentToZone,
  editOtherEquipmentInZone,
  removeOtherEquipmentFromZone,
} from '../../redux/zone/zone_other_equipment_actions';
import { searchOtherEquipmentByText } from '../../redux/other_equipment/equipment_actions';


export class OtherEquipmentDataTable extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isDuplicateModal: false,
    };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listOtherEquipment(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  render() {
    const { categoryOption } = this.state;

    const {
      zoneId,
      otherEquipmentList,
      filteredCount,
      isLoading,
      addOtherEquipmentToZone,
      editOtherEquipmentInZone,
      removeOtherEquipmentFromZone,
      isOtherEquipmentAdding,
      isOtherEquipmentEditing,
      isOtherEquipmentRemoving,
      errorMessage,
      t,
    } = this.props;

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    const columns = [
      {
        Header: '',
        accessor: 'equipment.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'equipment.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchOtherEquipmentByText(text, page, zoneId)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
        },
      },
      {
        Header: () => <b>{t('power (W)')}</b>,
        accessor: 'equipment.power_required',
        ...coeColumn,
        width: 200,
      },
      {
        Header: () => <b>{t('number of equipments')}</b>,
        accessor: 'quantity',
        ...textColumn,
        width: 120,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    const relationship = {
      create: ({ entityId, quantity }) => addOtherEquipmentToZone(entityId, quantity),
      edit: ({ id, quantity }) => editOtherEquipmentInZone(id, quantity),
      delete: id => removeOtherEquipmentFromZone(id),
      isCreating: isOtherEquipmentAdding,
      isEditing: isOtherEquipmentEditing,
      isDeleting: isOtherEquipmentRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <RelationDataTable
          columns={columns}
          data={otherEquipmentList}
          relationship={relationship}
          relationshipNameAccessor={item => item.equipment.name}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
          errorMessage={stringifyErrorMessage(errorMessage)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  otherEquipmentList: state.zoneOtherEquipment.orderedIds.map(id => state.zoneOtherEquipment.objects[id]),
  isLoading: state.zoneOtherEquipment.isLoading,
  isOtherEquipmentAdding: state.zoneOtherEquipment.isCreating,
  isOtherEquipmentEditing: state.zoneOtherEquipment.isEditing,
  isOtherEquipmentRemoving: state.zoneOtherEquipment.isDeleting,
  errorMessage: state.zoneOtherEquipment.errorMessage,
});

const mapDispatchToProps = (dispatch, ownedProps) => ({
  listOtherEquipment: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listOtherEquipmentInZone(pageSize, page, sorted, filtered, isPublic, ownedProps.zoneId))),
  addOtherEquipmentToZone: (equipmentId, quantity) =>
    defaultRejectHandler(dispatch(addOtherEquipmentToZone(equipmentId, ownedProps.zoneId, quantity))),
  editOtherEquipmentInZone: (id, quantity) =>
    defaultRejectHandler(dispatch(editOtherEquipmentInZone(id, quantity))),
  removeOtherEquipmentFromZone: id =>
    defaultRejectHandler(dispatch(removeOtherEquipmentFromZone(id))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(OtherEquipmentDataTable),
);



// WEBPACK FOOTER //
// ./src/components/zone/OtherEquipmentDataTable.js